import { Box, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import {
  backgroundColor04,
  BGColor02,
  blackShade19,
  blueColor04,
  greyColor35,
  regiterSuccessCardBorder,
} from "../../../../configs/styles/muiThemes";

function Card1({ data }) {
  return (
    <Stack alignItems="center" gap="12px" px={3}>
      <Box
        component="img"
        src="/./assets/image/invoice-generated.gif"
        width="110px"
        height="110px"
      />
      <Typography
        color={blackShade19}
        fontWeight={600}
        fontSize={14}
        textAlign="center"
      >
        You are about to download invoices and shipping label for{" "}
        <Typography
          component="span"
          color={blueColor04}
          fontWeight={600}
          fontSize={14}
        >
          {data?.length} orders.
        </Typography>{" "}
      </Typography>
      {/* <Typography
        color={blackShade19}
        fontWeight={600}
        fontSize={14}
        textAlign="center"
      >
        Please make sure you have reviewed the order details.
      </Typography> */}
      <Box
        sx={{
          backgroundColor: backgroundColor04,
          p: "6px 15px 5px",
          borderRadius: "10px",
          width: data?.length > 8 ? "100%" : "80%",
        }}
      >
        <Grid container spacing={1}>
          {data?.map((item, i) => (
            <Grid item md={data?.length > 8 ? 4 : 5}>
              <Typography fontSize={13} fontWeight={500} color={greyColor35}>
                #{item?.orderId}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Stack>
  );
}

export default Card1;
